import { render, staticRenderFns } from "./professional.vue?vue&type=template&id=6a3418c6&scoped=true&"
import script from "./professional.vue?vue&type=script&lang=js&"
export * from "./professional.vue?vue&type=script&lang=js&"
import style0 from "./professional.vue?vue&type=style&index=0&id=6a3418c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3418c6",
  null
  
)

export default component.exports